import styled, { css } from 'styled-components';
export const Container = styled.div `
  ${({ $withSeparator }) => $withSeparator &&
    css `
      padding-top: var(--space-200);
      margin-top: var(--space-400);
      border-top: 1px solid var(--border-tertiary);
    `}
`;
